var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center text-capitalize"},[_c('v-icon',{staticClass:"info--text",attrs:{"left":"","small":""}},[_vm._v("mdi-silverware-fork-knife")]),_vm._v(" "),_c('span',{staticClass:"caption"},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }